
/**
 * @param object
 * @returns {object}
 */
export const invert = function (object) {
    var result = {};
    var value;
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            value = object[key];
            if (value != null && typeof value.toString !== 'function') {
                value = toString.call(value)
            }
            result[value] = key;
        }
    }
    return result;
};

